// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__13uCV","header":"PatientBlock_header__18N-p","label":"PatientBlock_label__3DeXl","option":"PatientBlock_option__2sKUp"};